export default __webpack_public_path__ + "static/media/Comp 2_00039.fab27b41.png";